<template>
  <v-app class="auth-app">
    <v-main>
      <v-container fluid fill-height class="auth-page pa-4">
        <v-row align="center" justify="center" class="ma-0 fill-height">
          <v-col cols="12" sm="9" md="6" lg="4" xl="3" class="pa-0">
            <v-card class="auth-card" elevation="10">
              <div class="auth-header">
                <div class="brand-mark">
                  <img :src="$brand.markUrl" :alt="$brand.shortName" />
                </div>
                <div>
                  <div class="brand-name">{{ $brand.name }}</div>
                  <div class="brand-subtitle">Panel de administración</div>
                </div>
              </div>

              <v-card-text class="auth-body">
                <h1>Bienvenido</h1>
                <p>Ingresá con tus credenciales para administrar el sistema.</p>

                <v-alert v-if="mensajeError" type="error" text dense class="mb-5">
                  {{ mensajeError }}
                </v-alert>

                <form @submit.prevent="funIngresar">
                  <v-text-field
                    v-model.trim="usuario.email"
                    type="email"
                    label="Correo electrónico"
                    prepend-inner-icon="mdi-email-outline"
                    autocomplete="username"
                    outlined
                    dense
                    class="mb-2"
                  />

                  <v-text-field
                    v-model="usuario.password"
                    :type="mostrarPassword ? 'text' : 'password'"
                    label="Contraseña"
                    prepend-inner-icon="mdi-lock-outline"
                    :append-icon="mostrarPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                    autocomplete="current-password"
                    outlined
                    dense
                    @click:append="mostrarPassword = !mostrarPassword"
                  />

                  <div class="auth-actions">
                    <button type="button" class="text-action" @click="recuperarPassword">
                      ¿Olvidaste tu contraseña?
                    </button>
                  </div>

                  <v-btn
                    type="submit"
                    block
                    dark
                    color="#171717"
                    height="46"
                    class="submit-button"
                    :loading="ingresando"
                    :disabled="ingresando"
                  >
                    Ingresar
                  </v-btn>
                </form>
              </v-card-text>

              <div class="auth-footer">Acceso seguro a {{ $brand.productName }}</div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import authService from '../../service/AuthService';
import ability from '../../casl/ability';

export default {
  name: 'LoginView',

  data() {
    return {
      usuario: { email: '', password: '' },
      errores: {},
      mensajeError: '',
      ingresando: false,
      mostrarPassword: false,
    };
  },

  methods: {
    recuperarPassword() {
      this.$router.push('/recuperar-password');
    },

    async funIngresar() {
      this.errores = {};
      this.mensajeError = '';
      this.ingresando = true;

      try {
        const { data } = await authService.login(this.usuario);
        const permisos = data.user.permisos || [];

        permisos.push({ action: 'show', subject: 'auth' });
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('permisos', JSON.stringify(permisos));
        localStorage.setItem('userData', JSON.stringify(data.user));

        ability.update(permisos);
        this.$router.push({ name: 'perfil' });
      } catch (error) {
        const response = error && error.response ? error.response : null;
        const data = response ? response.data : null;

        if (response && response.status === 401) {
          this.mensajeError = 'El correo o la contraseña son incorrectos.';
        } else if (response && response.status === 422 && data && data.errors) {
          this.errores = data.errors;
          this.mensajeError = 'Revisá los datos ingresados.';
        } else {
          this.mensajeError = 'No pudimos iniciar sesión. Intentá nuevamente.';
        }
      } finally {
        this.ingresando = false;
      }
    },
  },
};
</script>

<style scoped>
.auth-app{background:#eee!important;text-align:left}.auth-page{min-height:100vh;background:radial-gradient(circle at 15% 20%,rgba(0,0,0,.045),transparent 27%),linear-gradient(135deg,#f8f8f8 0%,#e8e8e8 100%)}.auth-card{overflow:hidden;border:1px solid #dedede;border-radius:18px!important;background:#fff}.auth-header{min-height:92px;padding:22px 26px;display:flex;align-items:center;gap:13px;background:#151515}.brand-mark{width:43px;height:43px;padding:7px;display:flex;align-items:center;justify-content:center;border-radius:12px;background:#fff}.brand-mark img{width:100%;height:100%;object-fit:contain}.brand-name{color:#fff;font-size:1.05rem;font-weight:800}.brand-subtitle{margin-top:2px;color:#9c9c9c;font-size:.76rem}.auth-body{padding:30px 28px 24px!important}.auth-body h1{margin:0 0 5px;color:#171717;font-size:1.55rem;font-weight:800}.auth-body>p{margin:0 0 25px;color:#777;font-size:.88rem;line-height:1.45}.auth-actions{display:flex;justify-content:flex-end;margin:-2px 0 20px}.text-action{padding:0;border:0;background:none;color:#4c4c4c;font-size:.8rem;cursor:pointer}.text-action:hover{color:#000;text-decoration:underline}.submit-button{border-radius:9px!important;text-transform:none!important;font-weight:700;letter-spacing:.01em!important}.auth-footer{padding:13px 20px;border-top:1px solid #ededed;color:#999;background:#fafafa;text-align:center;font-size:.72rem}@media(max-width:600px){.auth-page{padding:14px!important}.auth-card{border-radius:14px!important}.auth-header{padding:19px 20px}.auth-body{padding:24px 20px 20px!important}}
</style>
